module.exports = __webpack_public_path__ + "img/event.c965fcdc.jpg";